if (!customElements.get("m-icon-box-distress")) {
    class MIconbox extends HTMLElement {
        constructor() {
        super();

        this.enableSlider = this.dataset.enableSlider === "true";
        this.items = this.dataset.items;
        this.showPagination = this.dataset.showPagination === "true";
        this.showNavigation = this.dataset.showNavigation === "true";
        this.slideContainer = this.querySelector(".swiper-container");
        }

        connectedCallback() {
            this.lastActive = null; 
            console.log("initClassification");
            this.initClassification();
        } 

        initClassification() {
            console.log("initClassification");
            const root = document.querySelector(".howtosay");
            if (!root) return;

            const classButtons = root.querySelectorAll(".classification");
            const blocks1 = root.querySelectorAll(".secondblock-1");
            const blocks2 = root.querySelectorAll(".secondblock-2");

            if (classButtons.length === 0) return;

            // 取得第一個分類的 ID
            const firstID = classButtons[0].dataset.classificationId;

            // ----- 預設啟動 -----
            this.applyClassification(firstID, classButtons, blocks1, blocks2);

            // ----- 綁定點擊事件 -----
            classButtons.forEach(btn => {
                btn.addEventListener("click", () => {
                const targetID = btn.dataset.classificationId;
                this.applyClassification(targetID, classButtons, blocks1, blocks2);
                });
            });
        }

        applyClassification(id, classButtons, blocks1, blocks2) {
            // 切換 active 樣式
            classButtons.forEach(btn => {
                btn.classList.toggle("active", btn.dataset.classificationId === id);
            });

            // 顯示/隱藏第二區塊
            blocks1.forEach(block => {
                block.style.display = (block.dataset.blockId === id) ? "flex" : "none";
            });

            blocks2.forEach(block => {
                block.style.display = (block.dataset.blockId === id) ? "block" : "none";
            });
        }


       
    }
    customElements.define("m-icon-box-distress", MIconbox);
}